import React from "react";
import { Props } from "./types";
import { Icon } from "./icon";
import { Form } from "./form";
import styles from "./styles.scss";
import { Tag } from "@common/tag";
import { VisibilityWatcher } from "@common/visibilityWatcher";

function Tags({ tags, project, uuid, removable, add }: Props) {
  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.tags}>
          {tags.length > 0 ? (
            <div className={styles.tags}>
              {tags.slice(0, 1).map((tag) => (
                <div key={tag.name} onClick={() => show()}>
                  <Tag
                    project={project}
                    tag={tag}
                    removable={removable}
                    removableId={uuid}
                  />
                </div>
              ))}
              {tags.length > 1 && (
                <p className={styles.text} onClick={() => show()}>
                  + {tags.slice(1).length}
                </p>
              )}
            </div>
          ) : (
            <div>
              <div onClick={() => show()}>
                <Icon className={styles.icon} />
              </div>
            </div>
          )}
          {isVisible && (
            <div className={styles.form}>
              <Form
                tags={tags}
                add={(nextTag) => {
                  add(nextTag);
                  hide();
                }}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { Tags };
